import { LinkComponent } from 'components/_ui/A';
import styles from './CollectionCard.module.css';
import { Environment } from 'services/Environment';
const { image } = require('cademy-shared-web');

type Types = {
    collection: {
        slug: string;
        img_url: string;
        name: string;
    };
};

export const CollectionCard = ({ collection: { img_url = '', slug, name } }: Types) => {
    return (
        <LinkComponent to={`/collection/${slug}`}>
            <div className={styles.card}>
                <picture>
                    <source
                        type="image/webp"
                        data-src={`${image.getBaseUrl(img_url)}w600.webp 2x`}
                        data-srcset={`${image.getBaseUrl(img_url)}w300.webp 1x, ${image.getBaseUrl(img_url)}w600.webp 2x`}
                    />
                    <source data-srcset={image.getFallbackUrl(img_url)} />
                    <img
                        src={`${Environment.ASSETS_URL}/images/placeholder.jpg`}
                        data-src={image.getFallbackUrl(img_url)}
                        className="lazyload"
                        alt={name + ' cademy course collection thumbnail'}
                    />
                </picture>
                <h3 className={styles.text}>{name}</h3>
            </div>
        </LinkComponent>
    );
};
